export default __webpack_public_path__ + "static/media/deddie-background.b2be473c.jpg";